import { c as _c } from "react/compiler-runtime";
import { Card } from '@onefootprint/ui';
import type { VaultType } from '@/entities/hooks/use-entity-vault';
import CardTitle from '../../../card-title';
import useField from '../../hooks/use-field';
import type { FieldsetField } from '../../hooks/use-fieldsets/use-fieldsets';
import Field from '../field';
type FieldsetProps = {
  fields: FieldsetField[];
  title: string;
  vaultData: VaultType | undefined;
};
const Fieldset = t0 => {
  const $ = _c(12);
  const {
    fields,
    title,
    vaultData
  } = t0;
  const getFieldProps = useField(vaultData);
  let t1;
  if ($[0] !== title) {
    t1 = <CardTitle title={title} />;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== fields || $[3] !== getFieldProps) {
    let t3;
    if ($[5] !== getFieldProps) {
      t3 = t4 => {
        const {
          di
        } = t4;
        const {
          label,
          value,
          isDecrypted,
          isEmpty
        } = getFieldProps(di);
        return <Field key={di} label={label} value={value} isDecrypted={isDecrypted} isEmpty={isEmpty} />;
      };
      $[5] = getFieldProps;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = fields.map(t3);
    $[2] = fields;
    $[3] = getFieldProps;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <Card.Body className="flex-1 py-1.5"><dl>{t2}</dl></Card.Body>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t3) {
    t4 = <Card.Root className="flex flex-col">{t1}{t3}</Card.Root>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export default Fieldset;